var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoostCustomerHeroBg = function SvgBoostCustomerHeroBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 763,
    height: 759,
    viewBox: "0 0 763 759",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "7.998%",
    x2: "29.506%",
    y1: "39.812%",
    y2: "99.528%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAC353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9A843"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M2.207 600.85c15.358 233.024 327.33 202.294 417.412-54.91 40.3-115.071 88.498-61.794 254.862-165.871 177.854-111.27 50.724-368.472-66.934-377.587C587.376.92 567.57.152 548.22.152 193.303.131-20.384 258.13 2.207 600.85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "100%",
    x2: "0%",
    y1: "35.513%",
    y2: "62.142%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9A340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FAD05C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "90.118%",
    x2: "7.029%",
    y1: "18.383%",
    y2: "82.754%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F89F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F9BB4F"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M51.471 300.203c71.898 33.571 159.545 48.794 251.479 38.806 205.54-22.326 358.362-162.552 353.644-318.916-16.067-10.1-32.737-16.347-49.047-17.61C587.376.92 567.57.152 548.222.15 308.332.14 132.972 117.978 51.472 300.203",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M203.042 666.036c3.615 28.277 12.228 55.093 25.099 79.987C307.351 720.408 380.191 681.933 416 572l44-14c40.736-125.064 68.674-70.918 216-156l24-11c27.594-14.944 10.118-36.03 25.837-55.973-36.448-8.913-75.255-13.68-115.379-13.678a514.75 514.75 0 0 0-55.567 3.022c-215.455 23.406-372.984 176.375-351.849 341.665z",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoostCustomerHeroBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boost-customer-hero-bg.0571310d67ca4b0f8e19e4a5949c5fdd.svg";